import React from 'react';

const Title = () => {
    return (
        <h2>Where in the World?</h2>
    )
}

export default Title;